/** Oddělovač elementu od bloku  */
export const ELEMENT_PREFIX = "__";
/** Oddělovač modifikátoru od bloku nebo elementu */
export const MODIFIER_PREFIX = "--";

/**
 * Funkce umožňující vytváření css tříd pomocí metodiky BEM
 */
export interface BEMClassNameCreator {
    /** Vrátí css třídu bloku */
    (): string;
    /** Funkce vracející css třídu elementu */
    element: (elementName: string, modifier?: string) => string;
    /** Funkce vracející css třídu modifikátoru */
    modifier: (modifierName: string) => string;
}

/**
 * Vytvoří funkci pro vytváření css tříd pomocí metodiky BEM
 * @param blockName Název Blocku z metodiky BEM
 */
export function setupBem(blockName: string): BEMClassNameCreator {
    const bem = () => {
        return blockName;
    };
    bem.element = (elementName: string, modifier?: string) => {
        return `${blockName}${ELEMENT_PREFIX}${elementName}${modifier ? `${MODIFIER_PREFIX}${modifier}` : ""}`;
    };
    bem.modifier = (modifierName: string) => {
        return `${blockName}${MODIFIER_PREFIX}${modifierName}`;
    };
    return bem;
}
